module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('navigator', {
    attrs: {
      "selectedProduct": _vm.getSelectedItem
    }
  }, [_c('template', {
    slot: "actionButtons"
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.stepNavigation.canGoBack
    },
    on: {
      "click": function($event) {
        return _vm.navigateStep(-1)
      }
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem || _vm.currentStep === 5) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.stepNavigation.canSave || _vm.hasAnyStepError
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < 5) ? _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": !_vm.stepNavigation.canProceed
    },
    on: {
      "click": function($event) {
        return _vm.navigateStep(1)
      }
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })]) : _vm._e()])], 2), _vm._v(" "), _c('steps', {
    attrs: {
      "currentStep": _vm.currentStep,
      "stepErrors": _vm.stepErrors
    },
    on: {
      "switchStep": _vm.handleStepClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexGrow1",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c(_vm.stepTemplate, {
    ref: "activeStep",
    tag: "component",
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "stepNavigationChanged": _vm.onStepNavigationChanged,
      "cancelling": _vm.cancel,
      "goToStep": _vm.goToStep,
      "readyToSave": _vm.save,
      "updateBackupGroup": _vm.updateBackupGroup
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-01990df1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01990df1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductForm.vue
// module id = 3082
// module chunks = 0